import React, { useEffect, useState } from "react";
import { useEthers } from "@usedapp/core";
import { ethers } from "ethers";
import {
  ModalButton,
  ModalContainer,
  ModalOverlay,
  ModalTitle,
} from "./styles";

import { DEGENCHAIN } from "../../constants";

const NetworkModal = () => {
  const { chainId, library } = useEthers();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Check if the current network matches DEGENCHAIN
    const isCorrectNetwork = parseInt(chainId) === DEGENCHAIN.chainId;
    setShowModal(!isCorrectNetwork);
  }, [chainId]);

  const switchToDegenChain = async () => {
    try {
      // Attempt to switch to DEGENCHAIN
      await library.provider.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: ethers.utils.hexlify(DEGENCHAIN.chainId) }],
      });
    } catch (error) {
      if (error.code === 4902) {
        try {
          await library.provider.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: DEGENCHAIN.chainId,
                rpcUrl: DEGENCHAIN.rpcUrl,
              },
            ],
          });
        } catch (addError) {
          console.error("Failed to add DEGENCHAIN", addError);
        }
      } else {
        console.error("Failed to switch to DEGENCHAIN", error);
      }
    }
  };

  if (showModal === false) return true;

  return (
    <ModalOverlay>
      <ModalContainer>
        <ModalTitle>You're connected to the wrong network.</ModalTitle>
        <p>Please switch to DegenChain.</p>
        <ModalButton onClick={switchToDegenChain}>Switch Network</ModalButton>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default NetworkModal;
